<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-07 15:22:03
 * @name: 待确认
 * @Description: 待确认
 * @FilePath: \project\src\views\index\afterSaleWaitConfirm\afterSaleWaitConfirmRouter.vue
 * @Author: desktop
-->
<template>
  <div class="afterSaleWaitConfirmRouter">
    <keep-alive :include="cashRouters">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "indexAfterSaleWaitConfirm",
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
};
</script>
<style lang="scss" scoped>
.afterSaleWaitConfirmRouter {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>